import { render, staticRenderFns } from "./CatalogLayoutSwitcher.vue?vue&type=template&id=ae5708a4&scoped=true&"
import script from "./CatalogLayoutSwitcher.vue?vue&type=script&lang=ts&"
export * from "./CatalogLayoutSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogLayoutSwitcher.vue?vue&type=style&index=0&id=ae5708a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5708a4",
  null
  
)

export default component.exports